import { graphql } from "../gql";

export default graphql(`
  query GetHeadToHeadPopularBets($input: OddsMarketTypesInput!) {
    event(input: $input) {
      popularBets {
        preferredOrder {
          americanOdds
          betUrl
          count
          events {
            competitionName
            eventName
            openDate
            selections {
              formattedHandicap
              handicap
              marketName
              runnerName
            }
          }
          type
        }
      }
    }
  }
`);
